"use strict";

/*global  jQuery*/
jQuery(function ($) {
$(function () {
 //読み込みが完了
//  $(window).on('load',function () { 
//    console.log('jQuery Page Loaded.');  
//  });

$(document).on('click', 'a[href*=\\#]:not([href=\\#])', function (event) {
  // スクロールの速度
  var speed = 500, // ミリ秒
  // アンカーの値取得
          href = $(this).attr("href"),
  // 移動先を取得
          target = $(href === "#" || href === "" ? 'html' : href),
  // 移動先を数値で取得
          position = target.offset().top +5;
  // スムーススクロール
  $('body,html').animate({scrollTop: position}, speed, 'swing');

  if($('input[name="menu-cb"]').prop('checked')) {
      $('input[name="menu-cb"]').prop('checked', false).change();;
  }

  return false;
});


    // ナビゲーションのリンクを指定
    var navLink = $('.menu-item a');
 
    // 各コンテンツのページ上部からの開始位置と終了位置を配列に格納しておく
    var contentsArr = new Array();
    linkSet();

   function linkSet() {
    // console.log('currentcheck');
    for (var i = 0; i < navLink.length; i++) {
        // コンテンツのIDを取得
      var targetContents = navLink.eq(i).attr('href');
      // ページ内リンクでないナビゲーションが含まれている場合は除外する
      if(targetContents.charAt(0) == '#') {
          // ページ上部からコンテンツの開始位置までの距離を取得
            var targetContentsTop = $(targetContents).offset().top;
          // ページ上部からコンテンツの終了位置までの距離を取得
            var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true) - 1;
          // 配列に格納
            contentsArr[i] = [targetContentsTop, targetContentsBottom]
      }
    };
   }
  


  // 現在地をチェックする
  function currentCheck() {
    // 現在のスクロール位置を取得
     var windowScrolltop = $(window).scrollTop();
     for (var i = 0; i < contentsArr.length; i++) {
        // 現在のスクロール位置が、配列に格納した開始位置と終了位置の間にあるものを調べる
       if(contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
             // 開始位置と終了位置の間にある場合、ナビゲーションにclass="current"をつける
            navLink.removeClass('current');
            navLink.eq(i).addClass('current');
             i == contentsArr.length;
         }
    };
}

// ページ読み込み時とスクロール時に、現在地をチェックする
$(window).on('load scroll', function() {
   currentCheck();
});
$(window).resize(function(){
  linkSet();
});

});
});

//touchstartに対応してたらtouchstart、してなければclick
let mytap = window.ontouchstart===null?"touchstart":"click";
// console.log('touch対応：' + mytap);

// DOM読み込み完了
// document.addEventListener('DOMContentLoaded', function(e) {
//   console.log('DOM Content Loaded.');
// }, false);



// 完全に読み込み完了
// window.addEventListener('load', function() {
//   console.log('Page Loaded.');
// });
